import {Client} from "./Client";
import {Address} from "./Address";
import {TimeSlot} from "./TimeSlot";
import {State} from "./State";
import {PaymentMode} from "./PaymentMode";
import {Zone} from "./Zone";
import {BillElements} from "./BillElement";
export class Order {
	id: number;
	totalPrice: number;
	date: Date;
	time: string;
	client: Client;
	deliveryAddress: Address;
	timeSlot: TimeSlot;
	state: State;
	paymentMode: PaymentMode;
	zone: Zone;
	billElementsList: Array<BillElements>;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/Order.ts